
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/control.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-control-demo-xflow-components-control"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/control.zh.md?type=demo')
};